const VIEW_STATE_KEY = 'crmViewStates';

type ViewType = 'list' | 'kanban' | 'grid';
type PageType = 'leads' | 'deals' | 'pipelines';

interface ViewStates {
  [key: string]: ViewType;
}

export const getStoredViewState = (page: PageType): ViewType | null => {
  try {
    const stored = localStorage.getItem(VIEW_STATE_KEY);
    if (!stored) return null;
    
    const viewStates: ViewStates = JSON.parse(stored);
    return viewStates[page] || null;
  } catch (error) {
    console.warn('Error reading view state:', error);
    return null;
  }
};

export const setViewState = (page: PageType, view: ViewType): void => {
  try {
    const stored = localStorage.getItem(VIEW_STATE_KEY);
    const viewStates: ViewStates = stored ? JSON.parse(stored) : {};
    
    viewStates[page] = view;
    localStorage.setItem(VIEW_STATE_KEY, JSON.stringify(viewStates));
  } catch (error) {
    console.warn('Error saving view state:', error);
  }
};

export const clearViewStates = (): void => {
  try {
    localStorage.removeItem(VIEW_STATE_KEY);
  } catch (error) {
    console.warn('Error clearing view states:', error);
  }
};

export const getDefaultViewForPage = (page: PageType): ViewType => {
  switch (page) {
    case 'leads':
      return 'kanban';
    case 'deals':
      return 'kanban';
    case 'pipelines':
      return 'kanban';
    default:
      return 'kanban';
  }
};
